import React from 'react';
import { Grid } from '@mui/material';
import HomeSection, { HomeSectionVariant } from '../../components/home/home-section';
import ImportantLinksCard from '../../components/home/important-links-card';
import { useGlobalState } from '../../global/context/global-context';
import { ouvUrl, sicUrl } from '../../../utils/environment';

export default function SectionImportantLinks({ variant = 'plain' }: { variant?: HomeSectionVariant }) {
  const { applicationData, parametersPortal } = useGlobalState();
  const cnpj = applicationData?.entity?.document || '';

  // Gera o nome da cidade sem espaços para o SEI
  const cityNameNoSpaces = applicationData?.entity?.address?.city
    ?.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/\s+/g, '') // Remove espaços
    || '';

  // Links para Cidadãos
  const citizenLinks = [
    {
      title: 'Consultar Diário Oficial',
      href: '/diario-oficial',
      icon: 'newspaper' as const,
      external: false,
    },
    {
      title: 'Acompanhar Licitações',
      href: '/licitacoes',
      icon: 'gavel' as const,
      external: false,
    },
    {
      title: 'Transparência Pública',
      href: '/contas-publicas',
      icon: 'eye' as const,
      external: false,
    },
    {
      title: 'GovHub-SIC',
      href: sicUrl(applicationData?.entity),
      icon: 'info-circle' as const,
      external: true,
    },
    {
      title: 'GovHub-Ouvidoria',
      href: ouvUrl(applicationData?.entity),
      icon: 'comments' as const,
      external: true,
    },
    {
      title: 'Perguntas Frequentes',
      href: '/perguntas-respostas',
      icon: 'question-circle' as const,
      external: false,
    },
  ];

  // Links para Servidores Públicos
  const serverLinks = [
    parametersPortal?.urlPaycheck && {
      title: 'Contracheque Online',
      href: parametersPortal.urlPaycheck,
      icon: 'money-check-alt' as const,
      external: true,
    },
    parametersPortal?.urlDaily && {
      title: 'Consultar Diárias',
      href: parametersPortal.urlDaily,
      icon: 'plane-departure' as const,
      external: true,
    },
    {
      title: 'Portal do Servidor',
      href: `http://docgedsistemas.com.br/portal-servidor?codEntidade=${cnpj}&empresa=3851`,
      icon: 'id-card' as const,
      external: true,
    },
    {
      title: 'Estrutura Administrativa',
      href: '/estrutura-administrativa',
      icon: 'sitemap' as const,
      external: false,
    },
    {
      title: 'Sistema e-GED',
      href: `http://docgedsistemas.com.br/minuspaper?codEntidade=${cnpj}&empresa=3851`,
      icon: 'folder-open' as const,
      external: true,
    },
    {
      title: 'Legislação Municipal',
      href: '/contas-publicas',
      icon: 'balance-scale' as const,
      external: false,
    },
  ].filter(Boolean) as any[];

  // Links para Empresas
  const companyLinks = [
    {
      title: 'Processos Licitatórios',
      href: '/licitacoes',
      icon: 'gavel' as const,
      external: false,
    },
    {
      title: 'Consulta de Processos (SEI)',
      href: `https://sip.${cityNameNoSpaces}.seibahia.ba.gov.br/login.php?sigla_orgao_sistema=${cityNameNoSpaces.toUpperCase()}&sigla_sistema=SEI`,
      icon: 'file-alt' as const,
      external: true,
    },
    {
      title: 'Contratos e Aquisições',
      href: '/contratos-aquisicoes',
      icon: 'file-contract' as const,
      external: false,
    },
    parametersPortal?.urlNfse && {
      title: 'Nota Fiscal Eletrônica',
      href: parametersPortal.urlNfse,
      icon: 'file-invoice' as const,
      external: true,
    },
    {
      title: 'Convênios e Repasses',
      href: '/convenios-repasses',
      icon: 'handshake' as const,
      external: false,
    },
    {
      title: 'Certidões Online',
      href: `http://docgedsistemas.com.br/certidoes?codEntidade=${cnpj}&empresa=3851`,
      icon: 'certificate' as const,
      external: true,
    },
  ].filter(Boolean) as any[];

  return (
    <HomeSection id="links-importantes" variant={variant} title="Links importantes" subtitle="Serviços organizados por público.">
      <Grid container spacing={{ xs: 2, md: 3 }}>
        <Grid item xs={12} md={4}>
          <ImportantLinksCard title="Cidadão" subtitle="Serviços para o cidadão" icon="users" links={citizenLinks} />
        </Grid>
        <Grid item xs={12} md={4}>
          <ImportantLinksCard title="Servidor público" subtitle="Portal do servidor" icon="id-badge" links={serverLinks} />
        </Grid>
        <Grid item xs={12} md={4}>
          <ImportantLinksCard title="Empresas" subtitle="Serviços para empresas" icon="building" links={companyLinks} />
        </Grid>
      </Grid>
    </HomeSection>
  );
}
